<template>
    <ProgressBar :value="value" :mode="mode" :showValue="showText"></ProgressBar>
</template>

<script>
import ProgressBar from 'primevue/progressbar';

export default {
    name: 'tw-progress',
    components: {
        ProgressBar
    },
    props: {
        value: Number,
        mode: String,
        showText: Boolean,
    }
}
</script>
